import { defineMessages } from 'react-intl';

export default defineMessages({
	categoryFilter: {
		defaultMessage: 'Category',
		description: 'Label for the category picker filter used to narrow article search results',
		id: 'sd.all.articles.result.category.filter.name',
	},
});
